import AbstractPage from './abstract-page';
import ShareComponent from '../../share';
import Picture from '../../picture';


export default class Comment extends AbstractPage {
  constructor(props) {
    super(props);
  }

  render() {
    const commentData = this.screenData;
    const buttonText = (commentData.buttonText) ? commentData.buttonText : 'Ответить';
    const button = (commentData.button) ? <button className="content__progress-button" type="button" onClick={() => this.onNext(this.screenData.next)}><span>{buttonText}</span></button> : '';
    const questionCounter = (this.progress) ? <div className="question-counter">
        {!commentData.endingScreen ?
        <span class="question-counter__title">
          {this.progress.questionNumber} / {this.progress.numberOfQuestion}<br/>
          <span>Урок</span>
        </span> : <div class="question-counter__winner"><span>6/6</span> <br/> Победа!</div>}
      </div> : '';
    const mainHeader = (this.props.data.title) ? <h1 className="content__game-title">{this.props.data.title}</h1> : '';
    const subHeader = (this.props.data.description) ? <span>{this.props.data.description}</span> : '';

    const commentDescription = (commentData.description) ? <div className="content__description" dangerouslySetInnerHTML={{__html: commentData.description}} /> : '';
    const commentAnswers = (commentData.answerList) ? commentData.answerList.map((answer) => {
      return answer[1] ? <li className="content__answer-item content__answer-item_selected"><p className="content__answer">{answer[0]}</p>{commentDescription}</li> : <li className="content__answer-item"><p className="content__answer">{answer[0]}</p></li>;
    }) : '';
    const questionDescription = (commentData.comment) ? <div className="content__main-text" dangerouslySetInnerHTML={{__html: commentData.comment}} /> : '';
    const shareButton = (commentData.shareButton) ? <div class="last__share-content">
      <h2 class="last__share-title">Поделиться:</h2>
      <ShareComponent {...commentData.shareButton}/>
    </div> : null;
    const textAfter = (commentData.textAfter) ? <div dangerouslySetInnerHTML={{__html: commentData.textAfter}} /> : null;

    return (
      <article className={commentData.specialClass}>
        <h1 class="title">
          Туториал. Онлайн-игра. Помоги российским гражданам
        </h1>

        {mainHeader}
        {subHeader}
        <Picture attributes={{src: commentData.imageSrc, width: 512, height: 386, alt: ''}} author={commentData.imageAuthor}/>
        {questionCounter}
        {questionDescription}
        <ul className="content__answer-list">
          {commentAnswers}
        </ul>
        {shareButton}
        {button}
        {textAfter}
      </article>
    );
  }

  static backDataToModel(step) {
    const result = AbstractPage.backDataToModel(step);
    result.button = (step.button) ? step.button : null;
    result.buttonText = (step.buttonText) ? step.buttonText : null;
    result.next = (step.next) ? step.next : null;
    result.textAfter = (step.textAfter) ? step.textAfter : null;
    result.answerList = (step.answerList && step.answerList.length) ? step.answerList : null;
    return result;
  }
}



// WEBPACK FOOTER //
// ./components/page/view/comment.js